export enum LogLevelType {
    Information = 'Information',
    Warning = 'Warning',
    Error = 'Error',
}